const nivolumabImgUrls = {
  anayaLogo: require('../assets/images/programs/nivolumab/anaya-logoo-without-bg.png'),
  heroSection: require('../assets/images/programs/nivolumab/hero-content.webp'),
  caregiverWithPatient: require('../assets/images/programs/nivolumab/caregiver-with-patient.webp'),
  chevronUp: require('../assets/images/programs/viemax-program/chevron-up.png'),
  chevronDown: require('../assets/images/programs/viemax-program/chevron-down.png'),
  nurseImg: require('../assets/images/programs/nivolumab/construction-illustration.webp'),

  video: {
    playIcon: require('../assets/icons/play-circle.png'),
    thumbnail: require('../assets/images/programs/nivolumab/video-thumbnail.webp'),
    videoUrl:
      'https://www.youtube.com/embed/XD4L2Vq7HQQ?list=PLpa6Divno66YWrmcLWwbh8Zmt4W_6P4rU',
    title: 'Why oncologists recommend Anaya Care?',
  },

  offerings: {
    careSpecialist: require('../assets/images/programs/nivolumab/offerings/care-specialist.webp'),
    //coachConsultations: require('../assets/images/programs/nivolumab/offerings/coach-consultations.webp'),
    coachConsultations: require('../assets/images/programs/nivolumab/offerings/coach-consultations-v2.png'),
    freeDrugSupport: require('../assets/images/programs/nivolumab/offerings/free-drug-support.webp'),
    curatedEducationalContent: require('../assets/images/programs/nivolumab/offerings/health-record-management.webp'),
    healthRecordManagement: require('../assets/images/programs/nivolumab/offerings/curated-educational-content.webp'),
  },
  careSpecialistBanner: require('../assets/images/programs/nivolumab/care-specialist-banner.webp'),
  coinWallet: require('../assets/images/programs/nivolumab/coin-wallet.webp'),
  offers: [
    // {
    //   img: require('../assets/images/programs/nivolumab/offers/nutritionist.webp'),
    //   title: 'Nutritionist',
    // },
    {
      img: require('../assets/images/programs/nivolumab/offers/psycologist.webp'),
      title: 'Psycologist',
    },
    {
      img: require('../assets/images/programs/nivolumab/offers/physiotherapist.webp'),
      title: 'Physiotherapist',
    },
    {
      img: require('../assets/images/programs/nivolumab/offers/lab-tests.webp'),
      title: 'Lab Test',
    },
  ],
  documentView: {
    header: require('../assets/images/programs/nivolumab/header-content.png'),
    sunflower: require('../assets/images/programs/nivolumab/rotating-flower.webp'),
  },
}

export const offeringSection = {
  offerings: [
    {
      title: 'Dedicated Care Specialist',
      desc: 'Stay connected with your dedicated guide for constant care and support throughout your treatment journey',
      image: nivolumabImgUrls.offerings.careSpecialist,
    },
    {
      //title: 'Consultations with Coaches',
      title: 'Free Consultations with Nutritionist',
      //desc: 'Personalised consultations with a dietitian, psychologist and physiotherapist to improve and support your health journey',
      desc: 'Ongoing personalised guidance from a nutritionist to support your health goals.',
      image: nivolumabImgUrls.offerings.coachConsultations,
    },
    {
      title: 'Free Drug Support',
      desc: 'On the purchase of prescribed medications, you may be eligible to receive additional medications free of cost.',
      image: nivolumabImgUrls.offerings.freeDrugSupport,
    },
    {
      title: 'Educational Content',
      desc: 'Explore comprehensive educational resources on the app and understand your condition better.',
      image: nivolumabImgUrls.offerings.curatedEducationalContent,
    },
    {
      title: 'Health Record Management',
      desc: 'Securely store and access all your medical records easily, retrieve them whenever you need.',
      image: nivolumabImgUrls.offerings.healthRecordManagement,
    },
  ],
}
export const faqs = [
  {
    title: 'Who should download this app?',
    answer:
      'Between a patient and a caregiver, we highly recommend that the patient downloads this app.',
  },
  {
    title: 'Is there an additional fee for this support program?',
    answer:
      'No, this is a free support program as part of your Cancer Drug. There are however certain services within the support program which follow a pay as you go model - for eg., buying care products, booking a test, etc.',
  },
  {
    title: 'How secure is my data?',
    answer:
      'All data is secure and stored in encrypted servers. Other than data that is willingly shared for the purposes of availing the service, no other data of the patient is accessed.',
  },
  {
    title: 'Who is eligible for this support program?',
    answer:
      'All patients who have been prescribed and have purchased Sigrima, Tukavo, Ujvira (for breast cancer) or Nivolumab (for other cancer types) are eligible for this program.',
  },
]
export const journeySteps = [
  { title: 'Upload your latest documents.' },
  { title: 'Documents will be verified by Care Specialist.' },
  { title: 'Your cancer care journey starts.' },
]
export const coinsCount = 250

export const document_types = [
  {
    document_type: 'dp',
    document_title: 'Doctor Prescription',
    button_text: 'Upload Prescription',
    description: `Upload your doctor’s prescription which mentions the cancer medication.`,
  },
]
export const anaya_care = 'anaya'
export default nivolumabImgUrls
